
// Vue
import {Options, Vue} from "vue-class-component";

// Store
import store from "@/store/index";

// Vendors
import moment from "moment";

// Models
import {AppCoachHealthRecordsRootListIndex} from "@/models/app/coach/health-records/root/list/index";
import {AppCommonUser} from "@/models/app/common/User";
import {ResponseIndex} from "@/models/response";

// Components
import {
  ElRow,
  ElCol,
} from "element-plus";
import AppCoachHealthRecordsRootListFormCreateIndexVue from "@/views/app/coach/health-records/root/list/form/create.vue";
import AppCoachHealthRecordsRootListFormUpdateIndexVue from "@/views/app/coach/health-records/root/list/form/update.vue";
import AppCoachHealthRecordsRootListFormRemoveIndexVue from "@/views/app/coach/health-records/root/list/form/remove.vue";
import AppCoachHealthRecordsRootListFormLookupDocumentIndexVue from "@/views/app/coach/health-records/root/list/form/lookup-document.vue";
import AppCoachHealthRecordsRootListFormUploadDocumentIndexVue from "@/views/app/coach/health-records/root/list/form/upload-document.vue";

// Services
import {getRequest} from "@/services/api/request";

@Options({
  props: [
    "players",
  ],
  components: {
    ElRow,
    ElCol,
    AppCoachHealthRecordsRootListFormCreateIndexVue,
    AppCoachHealthRecordsRootListFormUpdateIndexVue,
    AppCoachHealthRecordsRootListFormRemoveIndexVue,
    AppCoachHealthRecordsRootListFormLookupDocumentIndexVue,
    AppCoachHealthRecordsRootListFormUploadDocumentIndexVue,
  },
})
export default class AppCoachHealthRecordsRootListIndexVue extends Vue {
  isLoading: boolean | null = false;

  formData: any = {
    filter: {
      user_id: "*",
    },
    organization_id: store.getters.getOrganizationMember.organization_id,
  };

  moment: any = null;

  players: Array<AppCommonUser> = [];
  healthRecords: Array<AppCoachHealthRecordsRootListIndex> = [];

  async getHealthRecords(formData: any = null): Promise<void> {
    this.isLoading = true;

    if (formData) {
      this.formData = formData;
    }

    await getRequest({
      uri: `/common/health-records`,
      formData: this.formData,
      isProtected: true,
    }).then((r: ResponseIndex) => {
      if (r.data) {
        this.healthRecords = r.data;
      }
    });
    this.isLoading = false;
  }

  async created(): Promise<void> {
    this.moment = moment;
    await this.getHealthRecords();
  }
}
